export default __webpack_public_path__ + "static/media/WebGL.097299c5.svg";